module.exports = __webpack_public_path__ + "assets/img/C-2.83bc4fb3.jpg";